module.exports = __webpack_public_path__ + "img/新闻资讯banner.b6bc642a.png";